@if (useTemplate() === 'info-box') {
  @for (message of messageKey(); let last = $last; track $index) {
    <mwe-infobox [messageKey]="message" [class.mb-3]="!last" [class.d-block]="!last" type="neutral" />
  }
} @else {
  <mwe-infobox [messageKeys]="messageKeys()" type="info" />
}
